// Module
var code = "<p><strong>Placard ID: </strong><button class=\"ups-link\" type=\"button\" (click)=\"showDetail(dataSearch?.placardId)\">{{ dataSearch?.placardId }}</button></p>\r\n<p>\r\n    <strong>Status: </strong><span>Ready</span>\r\n</p>";
// Exports
module.exports = code;